import { PlayCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import { NavLink } from "react-router-dom";

function Guides() {
  const [guides, setGuides] = useState([
    "teacher_guide_1",
    "teacher_guide_2",
    "teacher_guide_3",
    "teacher_guide_4",
    "teacher_guide_5",
    "teacher_guide_6",
    "teacher_guide_7",
    "teacher_guide_8",
    "teacher_guide_9",
    "teacher_guide_10",
    "teacher_guide_11",
    "teacher_guide_12",
    "teacher_guide_13",
    "teacher_guide_14",
    "teacher_guide_15",
    "teacher_guide_16",
    "teacher_guide_17",
    "teacher_guide_18",
    "teacher_guide_19",
    "teacher_guide_20",
    "teacher_guide_21",
  ]);
  return (
    <main>
      <header>
        <h1>Teacher Guides</h1>
      </header>
      <section className="scenarios">
        <div className="wrapper">
          <div className="cards">
            {guides.map((guide, index) => {
              return (
                <NavLink
                  key={index}
                  className="card"
                  target="_blank"
                  to={`/guides/${guide}.pdf`}
                >
                  <PlayCircleOutlined className="icon" />
                  <div className="card-body">
                    <p className="card-title">
                      {guide
                        .replaceAll("_", " ")
                        .split(" ")[0]
                        .substring(0, 1)
                        .toUpperCase() +
                        guide.replaceAll("_", " ").split(" ")[0].substring(1) +
                        " "}

                      {guide
                        .replaceAll("_", " ")
                        .split(" ")[1]
                        .substring(0, 1)
                        .toUpperCase() +
                        guide.replaceAll("_", " ").split(" ")[1].substring(1) +
                        " "}
                      {guide.replaceAll("_", " ").split(" ")[2]}
                    </p>
                  </div>
                </NavLink>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Guides;
